// extracted by mini-css-extract-plugin
export default {"banner":"wideBanner_banner__KYF9A","media":"wideBanner_media__C5HqJ"};